import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/workspace/$workspaceSlug/settings/workspace/billing/cancel")(
  {
    component: PaymentCancelPage,
  },
);

function PaymentCancelPage() {
  const { t } = useTranslation("billing");
  const { workspaceSlug } = Route.useParams();
  const navigate = useNavigate();

  const handleGoToBilling = () => {
    navigate({
      to: "/workspace/$workspaceSlug/settings/workspace/billing",
      params: { workspaceSlug },
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center">
            <XCircle className="w-12 h-12 text-gray-500" />
          </div>
        </div>

        <h1 className="text-2xl font-bold mb-3">
          {t("payment_cancel.title", "Payment Cancelled")}
        </h1>

        <p className="text-muted-foreground mb-6">
          {t(
            "payment_cancel.description",
            "Your payment was cancelled. No charges have been made to your account.",
          )}
        </p>

        <div className="flex justify-center gap-4">
          <Button variant="outline" onClick={handleGoToBilling}>
            {t("payment_cancel.go_to_billing", "Back to Billing")}
          </Button>
        </div>
      </div>
    </div>
  );
}
